import { useQuery } from '@tanstack/react-query';
import type { CostSummaryItem, VendorSpendItem, PaymentStatusItem } from '@peles/shared';
import * as reportsApi from '../api/reports';

export function useEventCostSummary(eventId: string | undefined) {
  return useQuery<CostSummaryItem[]>({
    queryKey: ['reports', 'cost-summary', eventId],
    queryFn: () => reportsApi.getEventCostSummary(eventId!),
    enabled: !!eventId,
  });
}

export function useVendorSpend() {
  return useQuery<VendorSpendItem[]>({
    queryKey: ['reports', 'vendor-spend'],
    queryFn: () => reportsApi.getVendorSpend(),
  });
}

export function usePaymentStatus(eventId?: string) {
  return useQuery<PaymentStatusItem[]>({
    queryKey: ['reports', 'payment-status', eventId],
    queryFn: () => reportsApi.getPaymentStatus(eventId),
  });
}
